import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useAuthAccountClaims } from '@nbx/frontend-helpers/subscribe';
import OrdersClosed from 'components/orders/OrdersClosed';
import OrdersOpen from 'components/orders/OrdersOpen';
import TradeActivity from 'components/orders/TradeActivity';
import StickyContainer from 'components/shared/StickyContainer';
import QueryParamTabs from 'components/shared/QueryParamTabs';
import TabBar from 'components/shared/QueryParamTabs/TabBar';
import Heading from 'components/shared/Heading';
import { useIsMobile } from 'helpers/hooks';
import AnnualReport from './AnnualReport';
import AdminReport from './AdminReport';
import styles from './styles.module.scss';

function Orders(props) {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const accountClaims = useAuthAccountClaims();
  const isTestAccount = accountClaims?.roles?.includes('test');

  const tabs = [
    {
      label: isMobile ? t('common_open') : t('orders_open_orders'),
      queryParam: '',
      component: OrdersOpen
    },
    {
      label: isMobile ? t('common_closed') : t('orders_closed_orders'),
      queryParam: 'closed',
      component: OrdersClosed
    },
    {
      label: isMobile ? t('common_activity') : t('orders_trade_activity'),
      queryParam: 'activity',
      component: TradeActivity
    },
    {
      label: t('annual_report'),
      queryParam: 'annual-report',
      component: AnnualReport
    }
  ];

  if (isTestAccount && !isMobile) {
    tabs.push({
      label: 'Admin Report',
      queryParam: 'admin-report',
      component: AdminReport
    });
  }

  useEffect(() => {
    if (isMobile && window.scrollY > 60) window.scroll({ top: 60 }); // eslint-disable-line
  }, [isMobile, props.location.search]);

  const renderTabBar = tabProps => {
    if (isMobile) {
      return (
        <StickyContainer bg>
          <Heading tag="h3" styles={[styles.heading]}>
            {t('common_orders')}
          </Heading>
          <TabBar {...tabProps} />
        </StickyContainer>
      );
    }
    return <TabBar {...tabProps} />;
  };

  return (
    <QueryParamTabs
      tabs={tabs}
      tabProps={{ accountId: props.accountId }}
      location={window.location}
      renderCustomTabBar={renderTabBar}
    />
  );
}

Orders.propTypes = {
  accountId: PropTypes.string,
  location: PropTypes.object.isRequired
};

Orders.defaultProps = {
  accountId: undefined
};

export default Orders;
